__turbopack_context__.v({
  "categoryTags": "EventsCalendarView-module-scss-module__o6i3Ja__categoryTags",
  "daySelectorSpacing": "EventsCalendarView-module-scss-module__o6i3Ja__daySelectorSpacing",
  "eventFactsSpacing": "EventsCalendarView-module-scss-module__o6i3Ja__eventFactsSpacing",
  "favoriteButton": "EventsCalendarView-module-scss-module__o6i3Ja__favoriteButton",
  "header": "EventsCalendarView-module-scss-module__o6i3Ja__header",
  "headerCopy": "EventsCalendarView-module-scss-module__o6i3Ja__headerCopy",
  "headerTitle": "EventsCalendarView-module-scss-module__o6i3Ja__headerTitle",
  "pulse": "EventsCalendarView-module-scss-module__o6i3Ja__pulse",
  "scrollbar": "EventsCalendarView-module-scss-module__o6i3Ja__scrollbar",
  "scrollbarWrapper": "EventsCalendarView-module-scss-module__o6i3Ja__scrollbarWrapper",
  "skeletonCard": "EventsCalendarView-module-scss-module__o6i3Ja__skeletonCard",
  "skeletonContent": "EventsCalendarView-module-scss-module__o6i3Ja__skeletonContent",
  "skeletonImage": "EventsCalendarView-module-scss-module__o6i3Ja__skeletonImage",
  "skeletonWrapper": "EventsCalendarView-module-scss-module__o6i3Ja__skeletonWrapper",
  "slide": "EventsCalendarView-module-scss-module__o6i3Ja__slide",
  "slideContent": "EventsCalendarView-module-scss-module__o6i3Ja__slideContent",
  "slideImage": "EventsCalendarView-module-scss-module__o6i3Ja__slideImage",
  "slideImageWrapper": "EventsCalendarView-module-scss-module__o6i3Ja__slideImageWrapper",
  "slideLoading": "EventsCalendarView-module-scss-module__o6i3Ja__slideLoading",
  "slideTitle": "EventsCalendarView-module-scss-module__o6i3Ja__slideTitle",
  "swiperContainer": "EventsCalendarView-module-scss-module__o6i3Ja__swiperContainer",
  "underlineFullWidth": "EventsCalendarView-module-scss-module__o6i3Ja__underlineFullWidth",
});
